<div class="wrapper">

    <div class="status-list">
        <div *ngFor="let type of accountUserTypeMap | keyvalue"
            class="status"
            [class.selected]="isUserTypeSelected(type.key)"
            (click)="selectUserType(type.key)">
            {{type.value}}
        </div>
    </div>
    <app-empty-result *ngIf="!(isLoading$ | async) && !(accounts$ |async)?.length">
    </app-empty-result>
    <div *ngIf="(isLoading$ | async)"
        class="spinner-wrapper">
        <mat-spinner [diameter]="25"></mat-spinner>
    </div>
    <div class="users-wrapper"
        *ngIf="!(isLoading$|async) && (accounts$ |async)?.length">
        <cdk-virtual-scroll-viewport itemSize="ITEM_SIZE" 
            [style.height.px]="getScrolPanelHeight(accounts$ |async)" 
            class="search-scrolled-view">
            <div class="user-items-list">
                <div class="user-item"
                    [style.height.px]="getItemHeight(account)"
                    *cdkVirtualFor="let account of accounts$ | async">
                    <div class="user-icon">
                        <app-user-icon [type]="account.accountType"
                            [isPremium]="account.isPremium"
                            [width]="32"
                            [height]="32"></app-user-icon>
                    </div>
                    <div class="user-info"
                    >
                        <div class="view-contact"  *ngIf="account.accountType!=='admin'">
                            <a (click)="goToAccount(account)">View
                                contact</a>
                        </div>
                        <div class="actions">
                            <div *ngIf="account.accountType === 'customer'"
                                (click)="createOrderWithCustomer(account)"
                                class="icon-wrapper icon-call">
                                <svg-icon src="assets/images/add-order.svg"></svg-icon>
                            </div>
                            <div class="icon-wrapper icon-call"
                                (click)="callAccount(account)">
                                <svg-icon src="assets/images/icon-phone.svg"></svg-icon>
                            </div>
                            <div class="icon-wrapper icon-messages"
                                (click)="startChat(account)">
                                <svg-icon src="assets/images/icon-messages.svg"></svg-icon>
                            </div>
                        </div>
                        <div class="user-name">
                            {{account.contact.firstname}} {{account.contact.surname}}
                        </div>
                        <div class="user-type">
                            {{getUserAccountType(account)}}
                        </div>
                        <div class="user-details">
                            <div class="user-details-col">
                                <div class="user-details-header">
                                    Customer Details
                                </div>
                                <div class="user-details-contents">
                                    <a  class="user-details-link"
                                        href="mailto:charliestone@btinternet.com">{{account.username}}</a>
                                    <a *ngIf="account.contact.mobile"
                                        class="user-details-mobile"
                                        href="tel:{{account.contact.mobile}}">{{account.contact.mobile}}</a>
                                    <a *ngIf="account.contact.landline"
                                        class="user-details-landline"
                                        href="tel:{{account.contact.landline}}">{{account.contact.landline}}</a>
                                </div>
                            </div>
                            <div class="user-details-col">
                                <div class="user-details-header">
                                    Address
                                </div>
                                <div class="user-details-contents">
                                    <ng-container *ngIf="account.address.town">{{account.address.town}},
                                    </ng-container>
                                    <ng-container *ngIf="account.address.postcode">
                                        {{account.address.postcode}}
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="ongoing-orders"
                            *ngIf="account.orderCount">
                            <div class="icon-info">
                                <svg-icon src="assets/images/icon-circle-i.svg"></svg-icon>
                            </div>
                            <div class="ongoing-orders-message">
                                <div><span>{{account.orderCount}} ongoing orders for this customer</span></div>
                                <div class="ongoing-orders-message-link-cont">
                                    <a class="ongoing-orders-message-link" href="/accounts/overview/customer/{{account.id}}#orders_section">View orders</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </cdk-virtual-scroll-viewport>

    </div>
</div>